import ContentManager from "@/pages/admin/ContentManager";

export const configs = {
  berita: {
    resource: "news", title: "Berita", subtitle: "Kelola artikel & berita perusahaan.",
    fields: [
      { name: "title", label: "Judul" },
      { name: "excerpt", label: "Ringkasan", type: "textarea", rows: 2 },
      { name: "content", label: "Isi Berita", type: "textarea", rows: 6 },
      { name: "author", label: "Penulis" },
      { name: "date", label: "Tanggal (mis. 2026-05-10)" },
      { name: "image", label: "Gambar", type: "image" },
    ],
  },
  portofolio: {
    resource: "portfolio", title: "Portofolio", subtitle: "Kelola proyek & studi kasus.",
    fields: [
      { name: "title", label: "Judul Proyek" },
      { name: "client", label: "Nama Klien" },
      { name: "category", label: "Kategori" },
      { name: "description", label: "Deskripsi", type: "textarea" },
      { name: "image", label: "Gambar", type: "image" },
    ],
  },
  testimoni: {
    resource: "testimonials", title: "Testimoni", subtitle: "Kelola testimoni klien nyata.",
    fields: [
      { name: "name", label: "Nama" },
      { name: "role", label: "Jabatan" },
      { name: "company", label: "Perusahaan" },
      { name: "quote", label: "Testimoni", type: "textarea" },
      { name: "rating", label: "Rating (1-5)", type: "number" },
    ],
  },
  karir: {
    resource: "careers", title: "Lowongan Karir", subtitle: "Kelola lowongan pekerjaan.",
    fields: [
      { name: "title", label: "Posisi" },
      { name: "type", label: "Tipe (Full-time/Part-time)" },
      { name: "location", label: "Lokasi" },
      { name: "description", label: "Deskripsi", type: "textarea" },
      { name: "requirements", label: "Kualifikasi", type: "textarea" },
    ],
  },
  produk: {
    resource: "products", title: "Produk", subtitle: "Kelola produk unggulan.",
    fields: [
      { name: "name", label: "Nama Produk" },
      { name: "category", label: "Kategori" },
      { name: "description", label: "Deskripsi", type: "textarea" },
      { name: "price", label: "Harga (mis. Mulai Rp 5.000.000)" },
      { name: "image", label: "Gambar", type: "image" },
      { name: "featured", label: "Tampilkan sebagai Unggulan di Beranda", type: "checkbox" },
    ],
  },
  layanan: {
    resource: "services", title: "Layanan", subtitle: "Kelola layanan perusahaan.",
    fields: [
      { name: "title", label: "Nama Layanan" },
      { name: "icon", label: "Ikon", type: "select", options: ["shield-check", "bot", "megaphone", "settings", "building", "cpu"] },
      { name: "description", label: "Deskripsi", type: "textarea" },
      { name: "image", label: "Gambar", type: "image" },
      { name: "featured", label: "Layanan Unggulan", type: "checkbox" },
    ],
  },
};

export default function ContentPage({ configKey }) {
  const cfg = configs[configKey];
  return <ContentManager key={cfg.resource} {...cfg} />;
}
